module.exports = __webpack_public_path__ + "img/heart-half.14126dc8.svg";